import { render, staticRenderFns } from "./extra.vue?vue&type=template&id=f7bab432&scoped=true&"
import script from "./extra.vue?vue&type=script&lang=js&"
export * from "./extra.vue?vue&type=script&lang=js&"
import style0 from "./extra.vue?vue&type=style&index=0&id=f7bab432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7bab432",
  null
  
)

export default component.exports